import React, {Component} from 'react';
import {Link} from 'react-router-dom';

const CURRENT_YEAR = new Date().getFullYear()
export default class Footer extends Component {
  render() {
    return (
      <footer className="pt-4 main-footer pb-3">
        <div className="container">
          <h2 className="text-white font-title text-center mt-2 mb-4">meiaentrada.org.br</h2>
          <nav className='row'>

            <div className="col-sm-6 col-md-3">
              <ul className="py-0 my-0">
                <li className="py-1"><Link title="Home" to="/">Home</Link></li>
                <li className="py-1"><Link title="O que diz a lei" to="/lei">Lei da Meia-entrada</Link></li>
                <li className="py-1"><Link title="Validador oficial da CIE" to="/chaves-publicas">Chaves públicas</Link></li>
                <li className="py-1"><Link title="Perguntas e Respostas" to="/perguntas-e-respostas">FAQ</Link></li>
              </ul>
            </div>

            <div className="col-sm-6 col-md-3">
              <ul className="py-0 my-0">
                <li className="py-1"><Link title="Notícias" to="/noticias">Notícias</Link></li>
                <li className="py-1"><Link title="Termos de uso" to="/termos">Termos de Uso e Política de Privacidade</Link></li>
              </ul>
            </div>

          </nav>

          <div className="text-center mt-4">
            <span>@Meiaentrada.org.br - Todos os Direitos Reservados {CURRENT_YEAR}</span>
          </div>

        </div>

      </footer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/views/Shared/_Footer.js